import React from 'react';
import { Tooltip } from '@fiverr-private/tooltip';
import { I18n } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { HeadphonesIcon } from '@fiverr-private/icons';
import { LocalTimeInfo } from '../LocalTime/LocalTime';

import styles from './index.module.scss';

const AlignedHeadphonesIcon = () => (
    <span className={styles.iconWrapper}>
        <HeadphonesIcon size={16} />
    </span>
);

export const ProUserInfoContainer = ({
    timeZone,
    isOnline,
    withTooltip,
}: {
    timeZone: string;
    isOnline: boolean;
    withTooltip: boolean;
}) => {
    const {
        experience: { isBusiness: isBusinessExperience },
    } = getContext();

    const isOnlineTitle = isOnline ? (
        <I18n k="seller_pages_toolbox.local_time_info.online" />
    ) : (
        <I18n k="seller_pages_toolbox.local_time_info.offline" />
    );
    const content = <I18n k="seller_pages_toolbox.local_time_info.ask_about_call" />;
    return (
        <>
            <div className="flex co-text-dark m-b-4">
                {isOnlineTitle}
                {timeZone && (
                    <>
                        &nbsp;•&nbsp; <LocalTimeInfo timeZone={timeZone} />
                    </>
                )}
                {withTooltip && isBusinessExperience && (
                    <>
                        &nbsp;•&nbsp;
                        <Tooltip content={content} position="bottom">
                            <AlignedHeadphonesIcon />
                        </Tooltip>
                    </>
                )}
            </div>
            {!withTooltip && isBusinessExperience && (
                <div className="flex co-text-dark">
                    <AlignedHeadphonesIcon />
                    &nbsp;{content}
                </div>
            )}
        </>
    );
};
